const targets = {
  banner: document.querySelector('.event-banner'),
  exit: document.querySelector('.event-banner__close')
};

function unMountComponent() {
  const { banner } = targets;
  banner.classList.remove('event-banner--active');
}

function EventBanner() {
  const { banner, exit } = targets;
  if (typeof banner != "undefined" && banner != null)
    exit.addEventListener('click', (e) => {
        e.preventDefault();
        unMountComponent();
    });
}

export default EventBanner;


// WEBPACK FOOTER //
// ./src/js/app/components/EventBanner.js